import React from "react";
import UserSchedule from "views/user/schedule";
import UserClasses from "views/user/classes";
import SessionDetailPage from "views/user/classes/SessionDetailPage";
import UserSettings from "views/user/settings";
import ChangePassword from "views/user/settings/ChangePassword";
import SelfCheckin from "views/user/self-checkin";
import AttendanceHistory from "views/user/attendance-history";
import SessionHub from "views/admin/sessions";
import UserSessions from "views/admin/user-sessions";
import ClassMgmtView from "views/admin/classes-mgmt";
import StaffAttendance from "views/admin/participants/StaffAttendance";
import LeaveRequestsPage from "views/admin/leave-requests";
import {
  MdOutlineCalendarMonth,
  MdOutlineCameraAlt,
  MdOutlineEventBusy,
  MdOutlineFactCheck,
  MdOutlineLock,
  MdOutlineManageSearch,
  MdOutlineSchool,
  MdOutlineSettings,
} from "react-icons/md";

/** Routes dành cho STUDENT / TRAINER / TEACHER (/user/*) */
const userRoutes = [
  {
    name: "nav.classes",
    layout: "/user",
    path: "classes",
    icon: <MdOutlineSchool className="h-6 w-6" />,
    component: <UserClasses />,
    allowedRoles: ["STUDENT"],
  },
  {
    name: "nav.sessionDetail",
    layout: "/user",
    path: "classes/session/:sessionId",
    icon: <MdOutlineSchool className="h-6 w-6" />,
    component: <SessionDetailPage />,
    allowedRoles: ["STUDENT"],
    // Reached by tapping a session card in nav.classes — not a standalone
    // sidebar destination.
    hidden: true,
  },
  {
    name: "nav.schedule",
    layout: "/user",
    path: "schedule",
    icon: <MdOutlineCalendarMonth className="h-6 w-6" />,
    component: <UserSchedule />,
    allowedRoles: ["STUDENT"],
  },
  {
    name: "nav.sessions",
    layout: "/user",
    path: "sessions",
    icon: <MdOutlineCalendarMonth className="h-6 w-6" />,
    component: <SessionHub classBasePath="/user/classes-mgmt" />,
    allowedRoles: ["TRAINER", "TEACHER"],
  },
  {
    name: "nav.classesMgmt",
    layout: "/user",
    path: "classes-mgmt/*",
    icon: <MdOutlineCalendarMonth className="h-6 w-6" />,
    component: <ClassMgmtView />,
    allowedRoles: ["TRAINER", "TEACHER"],
    hidden: true,
  },
  {
    name: "nav.userSessions",
    layout: "/user",
    path: "user-sessions",
    icon: <MdOutlineManageSearch className="h-6 w-6" />,
    component: <UserSessions />,
    allowedRoles: ["TRAINER", "TEACHER"],
  },
  {
    name: "nav.staffAttendance",
    layout: "/user",
    path: "staff-attendance",
    icon: <MdOutlineFactCheck className="h-6 w-6" />,
    component: <StaffAttendance />,
    allowedRoles: ["TRAINER", "TEACHER"],
  },
  {
    name: "nav.leaveRequests",
    layout: "/user",
    path: "leave-requests",
    icon: <MdOutlineEventBusy className="h-6 w-6" />,
    component: <LeaveRequestsPage />,
    allowedRoles: ["TEACHER"],
  },
  {
    name: "nav.selfCheckin",
    layout: "/user",
    path: "self-checkin",
    icon: <MdOutlineCameraAlt className="h-6 w-6" />,
    component: <SelfCheckin />,
    allowedRoles: ["STUDENT"],
    // Standalone camera check-in entry point for when no specific session
    // is known yet (e.g. a kiosk/direct link). The per-session detail page
    // (views/user/classes/SessionDetailPage) embeds the same camera flow
    // inline instead of navigating here.
    hidden: true,
  },
  {
    name: "nav.attendanceHistory",
    layout: "/user",
    path: "attendance-history",
    icon: <MdOutlineFactCheck className="h-6 w-6" />,
    component: <AttendanceHistory />,
    allowedRoles: ["STUDENT"],
  },
  {
    name: "nav.settings",
    layout: "/user",
    path: "settings",
    icon: <MdOutlineSettings className="h-6 w-6" />,
    component: <UserSettings />,
    allowedRoles: ["STUDENT"],
  },
  {
    name: "nav.changePassword",
    layout: "/user",
    path: "change-password",
    icon: <MdOutlineLock className="h-6 w-6" />,
    component: <ChangePassword />,
    allowedRoles: ["STUDENT", "TRAINER", "TEACHER"],
  },
];

export default userRoutes;
